import { DocumentFile } from '../utils/document-file.model';

export interface ConstructionArea {
  id: string;
  order: number;
  name: string;
  masterConstructionAreaIds: string[];
  size: number;
  color: string;
  files: DocumentFile[];
}

export const constructionAreaChatbotFields = {
  id: { type: 'string', description: 'Must be specified for update or delete.' },
  name: {
    type: 'string',
    description: 'Must be specified for new entries. Otherwise should be only set if the intend it to change it.',
  },
  size: {
    type: 'number',
    description: 'Required for new entries. Otherwise should be only set if the intend is to change it.',
  },
  order: { type: 'number', description: 'Optional. Describes the order in the list.' },
  masterConstructionAreaIds: {
    type: 'array',
    description:
      'Optional. Master project construction area ids linked to this construction area. Set [] to remove master links.',
    items: { type: 'string' },
  },
};
